import React, { useState } from 'react';
import { urlService } from '../../routing/urlsService';
import {BaseGenericItemsStore, GenericItemsForm, GenericItemsUtils, IGetAllParams, MuiDataGrid, MuiIcons} from "@leap4/frontend";
import {connect, ConnectedProps} from "react-redux";
import {RootState} from "../../../interfaces/root-state.interface";
import {getSavedFilterModel, saveFilterModel} from "../../../utils/filterUtils";
import {integrationBaseUrl} from "../../../config/generals";
import {tableNames} from "../../../common/data/enums";
import {IIntegration} from './base/integration.interface';

type GridColDef = MuiDataGrid.GridColDef;
const { Toc: TocIcon } = MuiIcons;



    const mapStateToProps = (state: RootState) => ({
        selectedOrganization: state.auth.selectedOrganizationId
    });
    
    const connector = connect(mapStateToProps);
    
    type PropsFromRedux = ConnectedProps<typeof connector>;
    
    const fields = {
        isActive: 1,
        _id: 1,
        name: 1,
        adserver: 1,
        host: 1,
        bundleIdList: 1,
        demandWLTemplates: 1
    }
    const getParams: IGetAllParams = {
        fields,
        filter: {
            filter: {
                isDeleted: 0
            }
        }
    }
    
    
    let columns: GridColDef[];
    let store: BaseGenericItemsStore<IIntegration & { _id: string, isActive: boolean }>

    function setStoreAndColumns() {
        const storeAndColumns = GenericItemsUtils.GenerateDefaultStoreAndColumns({
            baseUrl: integrationBaseUrl,
        }, fields, {
            name: {editLinkFunc: (_id: string) => urlService.editIntegration(_id)},
            isActive: {},
            updated: {},
            created: {},
        })
        store = storeAndColumns.store;
        columns = storeAndColumns.columns;
    }

    const IntegrationsModule = (props: PropsFromRedux) => {
        const { selectedOrganization } = props;
        setStoreAndColumns();
        const [filterModel, setFilterModel] = useState(() => getSavedFilterModel(tableNames.INTEGRATIONS));
    
        const handleFilterChange = (newFilterModel) => {
            setFilterModel(newFilterModel || { items: [] });
            saveFilterModel(tableNames.INTEGRATIONS, newFilterModel);
        };
        return (
            <GenericItemsForm
            columns={columns}
            store={store}
            breadcrumbs={{
                link: urlService.integrations(),
                text: "Integrations Dashboard",
                icon: <TocIcon/>
            }}
            getAllParams={getParams}
            organization={selectedOrganization}
            tableProps={{
                pageSize: 100,
                style: {minHeight: "75vh"},
                columnVisibilityModel: { _id: false },
                componentsProps: {
                    panel: {
                        sx: { top: '-200px !important' },
                    },
                },
                filterModel: filterModel,
                onFilterModelChange: handleFilterChange,
            }}
            createButton={{
                to: urlService.newIntegration(),
                text: "create integration".toUpperCase()
            }}/>
        );
    };

export default connector(IntegrationsModule);

